import formatError from './format-error';

export default (errors: (Error | string)[]): string[] => {
  return ([] as string[]).concat(...errors.map(formatError));
};
